import { render, staticRenderFns } from "./ProjectsManagerPage.vue?vue&type=template&id=95aeb466"
import script from "./ProjectsManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95aeb466')) {
      api.createRecord('95aeb466', component.options)
    } else {
      api.reload('95aeb466', component.options)
    }
    module.hot.accept("./ProjectsManagerPage.vue?vue&type=template&id=95aeb466", function () {
      api.rerender('95aeb466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/manager/projects/ProjectsManagerPage.vue"
export default component.exports